import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { PlatformService } from '@panamax/app-state';
import { Facet, FacetValue } from '@usf/product-types';

@Component({
  selector: 'app-facet-value-list',
  templateUrl: './facet-value-list.component.html',
  styleUrls: ['./facet-value-list.component.scss'],
})
export class FacetValueListComponent implements OnInit {
  @Input() facet: Facet;
  @Input() facetValue: FacetValue;
  @Input() formGroup: FormGroup;
  @Output() clearSelectedFacetValue: EventEmitter<void> = new EventEmitter();

  facetValues: FacetValue[];
  label: string;
  selectedFacetValue: FacetValue;
  facetValueTotalCount: string;
  readonly SELECT_ALL = 'Select All';

  constructor(readonly platformService: PlatformService) {}

  ngOnInit() {
    if (!!this.facet) {
      this.facetValues = this.facet.values;
      this.label = this.facet.label;
    } else if (!!this.facetValue) {
      this.facetValues = this.facetValue?.childrenFacetValues;
      this.label = this.facetValue?.label;
      this.addSelectAll();
      this.facetValueTotalCount = ` (${this.facetValue.count})`;
    }
  }

  addSelectAll() {
    this.facetValues = [
      {
        ...this.facetValue,
        label: this.SELECT_ALL,
        childrenFacetValues: null,
      },
      ...this.facetValues,
    ];
  }

  navigateBack() {
    this.clearSelectedFacetValue.emit();
  }

  setSelectedFacetValue(facetValue: FacetValue) {
    this.selectedFacetValue = facetValue;
  }
}
